import React, { useState, useEffect } from 'react'
import FcModuleStyle from '../styles/fc.module.css';
import info from '../assets/info.png';
const CalProfitLoss = ({ simObj, setSimObj, fcPopup, setFcPopup, relaunchPopup, setRelaunchPopup }) => {
  const [isFluidPopup, setIsFluidPopup] = useState(false);
  const [infoOffset, setInfoOffset] = useState(false);
  const [bgColor, setBgColor] = useState("#008000");
  const clickHandler = (e) => {
    let image = document.querySelector("#mapeDetails img");
    if (e.target != image) {
      setIsFluidPopup(false);
    }
  }
  /*const calculatePosition = (event) => {

    let offsetTop;
    let offsetLeft;
    if (window.innerWidth > 610) {
      offsetTop = event.target.offsetTop - 43;
      offsetLeft = event.target.offsetLeft + 31;
    }
    else if ((window.innerWidth <= 610) && (window.innerWidth > 555)) {
      offsetTop = event.target.offsetTop - 53;
      offsetLeft = event.target.offsetLeft + 31;
    }
    else if ((window.innerWidth <= 555) && (window.innerWidth > 440)) {
      offsetTop = event.target.offsetTop - 75;
      offsetLeft = event.target.offsetLeft + 31;
    }
    else if (window.innerWidth <= 440) {
      offsetTop = event.target.offsetTop + 28;
      offsetLeft = event.target.offsetLeft - 169;
    }
    setInfoOffset({
      left: offsetLeft,
      top: offsetTop
    });
  };*/

  /*useEffect(() => {
    const detailIcon = document.querySelector("#mapeDetails");
    detailIcon.addEventListener("focus", (e) => {
      setIsFluidPopup(true);
      detailIcon.style.setProperty("outline", "none", "important");
      calculatePosition(e);
    });
    detailIcon.addEventListener("blur", (e) => {
      setIsFluidPopup(false);
    });

    if (window.innerWidth > 991) {
      document.querySelector("#mapeDetails img").addEventListener("mouseenter", () => setIsFluidPopup(true));
      document.querySelector("#mapeDetails img").addEventListener("mouseleave", () => setIsFluidPopup(false));
    }
  }, []);*/
  useEffect(() => {
    // console.log(simObj)
    const overAllMAPE = simObj?.laststate?.overAllMAPE;
    const mapeToGoal = simObj?.mapeToGoal
    if (overAllMAPE >= 0 && overAllMAPE <= 10) {
      setBgColor("#008000");
    } else if (overAllMAPE > 10 && overAllMAPE <= mapeToGoal) {
      setBgColor("#319ab7");
    } else if (overAllMAPE > mapeToGoal) {
      setBgColor("#DB0020");
    }
  }, [simObj?.laststate?.overAllMAPE])
  useEffect(() => {
    setTimeout(() => {
      if (isFluidPopup) {
        document.addEventListener("click", clickHandler);
      }
    }, 1000);
    if (!isFluidPopup) {
      document.removeEventListener("click", clickHandler);
    }
  }, [isFluidPopup])
  return (
    <div className={`${FcModuleStyle["pl-progress"]} ${fcPopup?.mapeReader ? `show ${FcModuleStyle['show']}` : ''} `} id="progressed-goal" >
      <div>
        <span style={{ "font-size": "18px;" }} data-tooltip="Mean Absolute Precent Error">MAPE: <strong>{simObj?.laststate?.overAllMAPE ? simObj?.laststate?.overAllMAPE : 0}%</strong></span>
        {/* <div className={`${FcModuleStyle['mape-container']}`}>
          <p>Mean Absolute Precent Error (MAPE)</p>
          <a href='#' id='mapeDetails'>
            <img src={info} alt='info' onClick={(e) => {
              calculatePosition(e);
              e.preventDefault();
              if (window.innerWidth < 991) {
                setIsFluidPopup(!isFluidPopup)
              }
            }}
              onMouseEnter={(e) => {
                if (window.innerWidth > 991) {
                  setIsFluidPopup(true);
                  calculatePosition(e);
                }
              }}
              onMouseLeave={() => window.innerWidth > 991 && setIsFluidPopup(false)}
            />
          </a>
        </div> */}
        {/* <div className={`ui fluid popup top left transition ${FcModuleStyle.ui} ${FcModuleStyle.fluid} ${FcModuleStyle.popup}`} role="alert" aria-live="assertive" style={{ display: isFluidPopup == true ? "block" : "none", top: infoOffset.top + "px", left: infoOffset.left + "px" }}>
          <p><strong>Mean Absolute Percentage Error (MAPE) for:</strong></p>
          <div className={`${FcModuleStyle["popup-info"]}`}>
            <div>
              <span>Regular</span>
              <span>
                <strong>{simObj?.laststate?.fuelInformations?.REGULAR?.meanAbsolutePercentageError ? simObj?.laststate?.fuelInformations?.REGULAR?.meanAbsolutePercentageError : 0} %</strong>
              </span>
            </div>
            <div>
              <span>Midgrade</span>
              <span>
                <strong>{simObj?.laststate?.fuelInformations?.MIDGRADE?.meanAbsolutePercentageError ? simObj?.laststate?.fuelInformations?.MIDGRADE?.meanAbsolutePercentageError : 0} %</strong>
              </span>
            </div>
            <div>
              <span>Premium</span>
              <span>
                <strong>{simObj?.laststate?.fuelInformations?.PREMIUM?.meanAbsolutePercentageError ? simObj?.laststate?.fuelInformations?.PREMIUM?.meanAbsolutePercentageError : 0} %</strong>
              </span>
            </div>
          </div>
        </div> */}

        {/* <div className={`${FcModuleStyle.progress}`} role="progressbar">
            <div className={`background`} id={`${FcModuleStyle.profitLoss}`}>
              <div className={`${FcModuleStyle['progress-fg']}`} style={{ "width": simObj?.laststate?.overAllMAPE + "%"}}></div>
            </div>
          </div> */}
         {/* <div className={`${FcModuleStyle['progress-fg']}`} style={{ "width": simObj?.laststate ? (Number(simObj?.laststate?.overAllMAPE * 2) > 100) ? "100%" : (simObj?.laststate?.overAllMAPE * 2) + "%" : "0%", "background-color": bgColor }}></div> */}
        <div className={`${FcModuleStyle['mape-progress-bar']}`}>
          
          <div className={`${FcModuleStyle.progress}`} role="progressbar">
            <div className={`${FcModuleStyle['background']}`}>
              {
                simObj?.laststate?.overAllMAPE >= 0 && simObj?.laststate?.overAllMAPE <= 50 && <div className={`${FcModuleStyle['progress-fg']}`} style={{ "width": simObj?.laststate ? (Number(simObj?.laststate?.overAllMAPE * 2) > 100) ? "100%" : (simObj?.laststate?.overAllMAPE * 2) + "%" : "0%", "background-color": bgColor }}></div>
              }
              {
                simObj?.laststate?.overAllMAPE > 50 && <div className={`${FcModuleStyle['progress-fg']}`} style={{ "width": simObj?.laststate ? (Number(simObj?.laststate?.overAllMAPE) > 100) ? "100%" : (simObj?.laststate?.overAllMAPE) + "%" : "0%", "background-color": bgColor }}></div>
              }
            </div>
          </div>
          <div className={`${FcModuleStyle["quarter-line"]}`}>
            {simObj?.laststate?.overAllMAPE >= 0 && simObj?.laststate?.overAllMAPE <= 50 && (
              <>
                <div style={{left:0*(100/50)  + "%"}}>0%</div>
                <div style={{left:10*(100/50)-5 + "%"}}>10%</div>
                <div style={{left:25*(100/50)-5 + "%"}}>25%</div>
                <div style={{left:35*(100/50)-5 + "%"}}>35%</div>
                <div style={{left:50*(100/50)-5 + "%"}}>50%</div>
              </>
            )}
            {simObj?.laststate?.overAllMAPE > 50 && (
              <>
                <div style={{left:0*(100/100)  + "%"}}>0%</div>
                <div style={{left:50*(100/100)-5 + "%"}}>50%</div>
                <div style={{left:100*(100/100)-5+ "%"}}>100%</div>
              </>
            )}
          </div>
        </div>
        <ul className={`${FcModuleStyle["info-data"]}`} role='list'>
            {simObj?.optionsAvailable?.REGULAR ? (
              <li role='listitem'>
                <span>Regular</span>
                <span className={`${FcModuleStyle["values-font"]}`}>
                  <strong>{simObj?.laststate?.fuelInformations?.REGULAR?.meanAbsolutePercentageError ? Math.floor(simObj?.laststate?.fuelInformations?.REGULAR?.meanAbsolutePercentageError) : 0}%</strong>
                </span>
              </li>
            ) : null}
            {simObj?.optionsAvailable?.MIDGRADE ? (
              <li role='listitem' className={`${FcModuleStyle["midgrade-block"]}`} style={simObj?.optionsAvailable?.PREMIUM ? {}:{borderRight:"none"}}>
                <span>Midgrade</span>
                <span className={`${FcModuleStyle["values-font"]}`}>
                  <strong>{simObj?.laststate?.fuelInformations?.MIDGRADE?.meanAbsolutePercentageError ? Math.floor(simObj?.laststate?.fuelInformations?.MIDGRADE?.meanAbsolutePercentageError) : 0}%</strong>
                </span>
              </li>
            ) : null}
            {simObj?.optionsAvailable?.PREMIUM ? (
              <li role='listitem'>
                <span>Premium</span>
                <span className={`${FcModuleStyle["values-font"]}`}>
                  <strong>{simObj?.laststate?.fuelInformations?.PREMIUM?.meanAbsolutePercentageError ? Math.floor(simObj?.laststate?.fuelInformations?.PREMIUM?.meanAbsolutePercentageError) : 0}%</strong>
                </span>
              </li>
            ): null}
          </ul>
      </div>
    </div>
  )
}

export default CalProfitLoss
